import React from 'react';

import { Popup } from '@shared/ui';

interface AddEmployerPopupProps {
    isOpen: boolean;
    onHide: () => void;
    t: (key: string) => string;
}

export const AddEmployeePopup = ({ isOpen, onHide, t }: AddEmployerPopupProps) => (
    <Popup
        title={t('AddEmployerToTeam.Popup.HeaderText')}
        type="alert"
        isOpen={isOpen}
        onHidePopup={onHide}
        contentText={t('AddEmployerToTeam.Popup.ContentText')}
    />
);
